import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import {
  adminDetail,
  fileUpload,
  getDetailSettings,
  updateAdmin,
} from "../../store/actions";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import Loading from "../../Common/extra/loading";
import PhoneInput from "react-phone-input-2";
import { isEmail, isEmpty } from "validator";
import { useSelector } from "react-redux";
import { checkValidations } from "../../Services/Helper";
import { MenuItem, Select } from "@material-ui/core";

const ProfileForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const Admin = JSON.parse(localStorage.getItem("adminData"));
  const adminData = useSelector((s) => s.Signatures?.adminDetail?.data);
  const basicSettings = useSelector((s) => s?.Signatures?.detailSettings?.data);
  const [adminDetails, setAdminDetails] = useState({
    profile_image: "",
    name: "",
    last_name: "",
    email: "",
    fax: "",
    mobile_number: "",
    office: "",
    company_title: "",
    office_address: "",
  });

  const [errors, setError] = useState({
    profile_image: "",
    name: "",
    last_name: "",
    email: "",
    fax: "",
    mobile_number: "",
    office: "",
    company_title: "",
    office_address: "",
  });

  useEffect(() => {
    if (adminData) {
      setAdminDetails((pre) => ({
        ...pre,
        profile_image: adminData?.profile_image || "",
        name: adminData?.name || "",
        fax: adminData?.fax || "",
        email: adminData?.email || "",
        mobile_number: adminData?.mobile_number || "",
        last_name: adminData?.last_name || "",
        office: adminData?.office || "",
        company_title: adminData?.company_title || "",
        office_address: adminData?.office_address || "",
      }));
    }
  }, [adminData]);

  useEffect(() => {
    dispatch(getDetailSettings());
  }, []);

  const handleFileProvider = (event) => {
    setLoading(true);
    let image = event.target.files[0];
    let formData = new FormData();
    formData.append("project_image[]", image);

    const callback = (url) => {
      setAdminDetails((pre) => ({ ...pre, profile_image: url?.files[0] }));
      setLoading(false);
    };

    dispatch(fileUpload(formData, null, callback));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const validate = checkValidations(adminDetails);

    const callBack = (response) => {
      setLoading(false);
      if (response.data) {
        toast.success("Profile Updated!");
        dispatch(adminDetail(Admin?.id));
        setTimeout(() => {
          navigate("/customers");
        }, 500);
      } else {
      }
    };

    if (!validate.error || validate.error == "Profile_image is required!") {
      setLoading(true);
      dispatch(
        updateAdmin(
          {
            ...adminDetails,
            mobile_number: "+" + adminDetails.mobile_number,
            userId: Admin?.id,
          },
          callBack
        )
      );
    } else {
      if (adminDetails.name == "") {
        setError((pre) => ({ ...pre, name: "Required" }));
      }
      if (adminDetails.last_name == "") {
        setError((pre) => ({ ...pre, last_name: "Required" }));
      }
      if (adminDetails.email == "") {
        setError((pre) => ({ ...pre, email: "Required" }));
      }
      // if (adminDetails.fax == "") {
      //   setError((pre) => ({ ...pre, fax: "Required" }));
      // }
      if (adminDetails.mobile_number == "") {
        setError((pre) => ({ ...pre, mobile_number: "Required" }));
      }
      if (adminDetails.office == "") {
        setError((pre) => ({ ...pre, office: "Required" }));
      }
      if (adminDetails.company_title == "") {
        setError((pre) => ({ ...pre, company_title: "Required" }));
      }
      if (adminDetails.office_address == "") {
        setError((pre) => ({ ...pre, office_address: "Required" }));
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const Error = { ...errors };

    switch (name) {
      case "name":
        Error[name] = "";
        if (value.length < 1) {
          Error[name] = "Required";
          Error["disabled"] = true;
        } else {
          Error["disabled"] = true;
        }
        break;

      case "last_name":
        Error[name] = "";
        if (value.length < 1) {
          Error[name] = "Required";
          Error["disabled"] = true;
        } else {
          Error["disabled"] = true;
        }
        break;

      // case "fax":
      //   Error[name] = "";
      //   if (value.length < 1) {
      //     Error[name] = "Required";
      //     Error["disabled"] = true;
      //   } else {
      //     Error["disabled"] = true;
      //   }
      //   break;

      case "email":
        if (isEmpty(value)) {
          Error[name] = "Required";
          Error["disabled"] = true;
        } else if (!isEmail(value)) {
          Error[name] = "Invalid Email";

          Error["disabled"] = true;
        } else {
          Error[name] = "";
          Error["disabled"] = true;
        }
        break;

      case "office":
        Error[name] = "";
        if (value.length < 1) {
          Error[name] = "Required";
          Error["disabled"] = true;
        } else {
          Error["disabled"] = true;
        }
        break;

      case "company_title":
        Error[name] = "";
        if (value.length < 1) {
          Error[name] = "Required";
          Error["disabled"] = true;
        } else {
          Error["disabled"] = true;
        }
        break;

      case "office_address":
        Error[name] = "";
        if (value.length < 1) {
          Error[name] = "Required";
          Error["disabled"] = true;
        } else {
          Error["disabled"] = true;
        }
        break;

      default:
        break;
    }
    setAdminDetails((pre) => ({ ...pre, [name]: value }));
    setError((pre) => ({ ...pre, ...Error }));
  };

  const handlePhone = (name, phoneNumber, dialCode, validate) => {
    if (!phoneNumber || !dialCode) return false;
    const Error = { ...errors };

    switch (name) {
      case "mobile_number":
        if (!validate) {
          Error[name] = "Invalid Number";
        } else {
          Error[name] = "";
        }
        break;

      default:
        break;
    }
    setAdminDetails((pre) => ({
      ...pre,
      [name]: phoneNumber,
    }));
    setError((pre) => ({ ...pre, ...Error }));
  };
  return (
    <>
      {loading && <Loading className={"cstmLoader"} />}
      <section className="profile-main py-3">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="top mb-2">
                <h4 className="dashboard-head m-0">Update Profile Image</h4>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="bg-white card-box px-4 py-3 rounded">
                <Form>
                  <Row>
                    <Col lg="12" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Profile Image
                      </label>
                      <div className="upload-file position-relative">
                        <input
                          type="file"
                          onChange={(e) => handleFileProvider(e)}
                          className="position-absolute"
                        />
                        <div className="inner position-relative">
                          <img
                            src={
                              adminDetails?.profile_image
                                ? adminDetails?.profile_image
                                : "/assets/images/dummy-profile"
                            }
                            alt=""
                            className="img-fluid w-100 h-100 rounded-circle"
                          />
                          <span className="btn rounded-circle d-flex align-items-center justify-content-center position-absolute">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                            >
                              <path
                                d="M5.2125 11.1975L8.3925 6.9525L14.76 1.65C15.0525 1.3575 15.54 1.3575 15.8175 1.65L16.35 2.1825C16.6425 2.46 16.6425 2.9475 16.35 3.24L11.0475 9.6075L6.8025 12.7875L5.2125 11.1975M6.27 13.32L4.68 11.73L2.5575 12.7875L1.5 15.9675L3.09 14.3775C3.24 14.25 3.4725 14.25 3.6225 14.3775C3.75 14.5275 3.75 14.76 3.6225 14.91L2.0325 16.5L5.2125 15.4425L6.27 13.32Z"
                                fill="white"
                              />
                            </svg>
                          </span>
                        </div>
                      </div>
                      <p className="small-text m-0 text-muted">
                        Max. upload file size: 5MB
                      </p>
                    </Col>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        First Name
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={adminDetails.name}
                        onChange={handleChange}
                        placeholder=""
                        className="form-control"
                      />
                      <span className="note error_note py-2 m-0 text-danger">
                        {errors.name}
                      </span>
                    </Col>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Last Name
                      </label>
                      <input
                        type="text"
                        name="last_name"
                        value={adminDetails.last_name}
                        onChange={handleChange}
                        placeholder=""
                        className="form-control"
                      />
                      <span className="note error_note py-2 m-0 text-danger">
                        {errors.last_name}
                      </span>
                    </Col>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Email
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={adminDetails.email}
                        onChange={handleChange}
                        placeholder=""
                        className="form-control"
                      />
                      <span className="note error_note py-2 m-0 text-danger">
                        {errors.email}
                      </span>
                    </Col>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Fax No
                      </label>
                      <input
                        type="number"
                        name="fax"
                        value={adminDetails.fax}
                        onChange={handleChange}
                        placeholder=""
                        className="form-control"
                      />
                      <span className="note error_note py-2 m-0 text-danger">
                        {errors.fax}
                      </span>
                    </Col>
                    <Col lg="6" className="my-2">
                      <label for="" className="form-label2 m-0">
                        Tel No
                      </label>
                      <PhoneInput
                        country={"us"}
                        placeholder="Enter Tel No"
                        value={adminDetails.mobile_number}
                        onChange={(data, country) => {
                          let validateWithLength = country.format?.split(".");
                          validateWithLength = validateWithLength?.length - 1;
                          if (validateWithLength == data.length) {
                            handlePhone(
                              "mobile_number",
                              data,
                              country.dialCode,
                              true
                            );
                          } else {
                            handlePhone(
                              "mobile_number",
                              data,
                              country.dialCode,
                              false
                            );
                          }
                        }}
                      />
                      <span className="note error_note py-2 m-0 text-danger">
                        {errors.mobile_number}
                      </span>
                    </Col>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Office No
                      </label>
                      <input
                        type="number"
                        name="office"
                        value={adminDetails.office}
                        onChange={handleChange}
                        placeholder=""
                        className="form-control"
                      />
                      <span className="note error_note py-2 m-0 text-danger">
                        {errors.office}
                      </span>
                    </Col>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Title/Position in Company
                      </label>
                      <input
                        type="text"
                        name="company_title"
                        value={adminDetails.company_title}
                        onChange={handleChange}
                        placeholder=""
                        className="form-control"
                      />
                      <span className="note error_note py-2 m-0 text-danger">
                        {errors.company_title}
                      </span>
                    </Col>
                    <Col lg="6" className="my-2 doc-select">
                      <label htmlFor="" className="form-label2 m-0">
                        Office Address
                      </label>
                      <Select
                        className="demo-simple-select-label mt-2"
                        id="demo-simple-select"
                        name="office_address"
                        value={adminDetails.office_address}
                        onChange={handleChange}
                        MenuProps={basicSettings?.contact_address}
                      >
                        {basicSettings &&
                          basicSettings?.contact_address &&
                          basicSettings?.contact_address.length > 0 &&
                          basicSettings?.contact_address.map((item, idx) => {
                            return (
                              <MenuItem key={item} value={item}>
                                {item}
                              </MenuItem>
                            );
                          })}
                      </Select>
                      <span className="note error_note py-2 m-0 text-danger">
                        {errors.office_address}
                      </span>
                    </Col>
                    <Col lg="12" className="my-2">
                      <div className="pt-4 btn-wrp d-flex algign-items-center">
                        <Button
                          onClick={handleSubmit}
                          // disabled={isDisabled}
                          className="d-flex align-items-center justify-content-center me-2"
                        >
                          Save
                        </Button>
                        <Link
                          to="/customers"
                          className="d-flex btn-2 border align-items-center justify-content-center me-2"
                        >
                          <span className="me-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="9"
                              viewBox="0 0 12 9"
                              fill="none"
                            >
                              <path
                                d="M2.8725 3.75L5.5575 1.0575L4.5 0L0 4.5L4.5 9L5.5575 7.9425L2.8725 5.25H12V3.75H2.8725Z"
                                fill="black"
                              />
                            </svg>
                          </span>
                          Back
                        </Link>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
export default ProfileForm;
